import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import NakladoveStrediskoField from "../fields/NakladoveStrediskoField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro změnu názvu objednávky na objednávce.
 */
class NakladoveStrediskoObjednavkaForm extends Component<WithTranslation> {

    static formName = 'NakladoveStrediskoObjednavkaForm';

    static propTypes = {
        nakladovaStrediskaList: PropTypes.array.isRequired, // seznam existujících nákladových středisek
    };

    render() {
        const {onClose, submitting, handleSubmit, nakladovaStrediskaList, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.Base label={t('order.name')}
                         name="naklStredObjednavka"
                         disabled={submitting}
                         componentClass={NakladoveStrediskoField}
                         nakladovaStrediska={nakladovaStrediskaList} />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: NakladoveStrediskoObjednavkaForm.formName,
})(NakladoveStrediskoObjednavkaForm)));
